import classnames from 'classnames';
import Utils from 'Utils';
import evtBus from 'evtBus';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Button, Typography, message, Spin, Empty } from 'antd';
import useFooter from 'useFooter';
import Loading from 'ui-loading';
import Err from 'ui-error';
import AppItem from './ui-ext-item';
import AppList from './ui-ext-list';
import AppSlider from './ui-ext-slider';
import request from 'request';
import imgEmpty from 'assets/img/empty.png';
import styles from './style.scss?__local';
import { useAction } from '@/hooks/useAction';
import { getExtList } from '@/api/api';
import * as R from 'ramda'

function Home(route) {
  useFooter()

  const fetch = useMemo(() => {

    const url = request.api.tagsList;

    return request({
      type: 'GET',
      url,
    })
  }, [])

  let [fetchRes, setFetchRes] = useState(null)

  useEffect(() => {
    fetch.done(data => setFetchRes({data}))
    fetch.fail(err => setFetchRes({err}))

    return () => {
      setFetchRes = () => {}
    }
  }, [])

  const elmLoading = fetch.state() == 'pending' ? <Loading /> : null
  const elmErr = fetch.state() == 'rejected' ? <Err err={`获取数据失败：${fetchRes.err}`} /> : null
  const elmApp = fetch.state() == 'resolved' ? <App data={ {tagsData: fetchRes?.data || {}} } /> : null

  return (
    <div className={styles.app}>
      {elmLoading}
      {elmErr}
      {elmApp}
    </div>
  )
}

const renderAppList = extLists => (
  // 分开奇数 偶数 采用瀑布流方式 解决这个布局显示间距问题
  <div className={styles['shelf-bd']}>
    <div className={styles['shelf-list']}>
      {
        extLists.length > 0 ?
          (
            <>
              <div className={styles['shelf-half']}>
                {(extLists || []).filter((item, idx) => idx % 2 === 0).map(item => (
                  <div className={styles['shelf-item']} key={`${item.extUuid}.${item.extVersionId}`}>
                    <AppItem
                      data={item}
                    />
                  </div>
                ))}
              </div>
              <div className={styles['shelf-half']}>
                {(extLists || []).filter((item, idx) => idx % 2 !== 0).map(item => (
                  <div className={styles['shelf-item']} key={`${item.extUuid}.${item.extVersionId}`}>
                    <AppItem
                      data={item}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            null
          )
      }
    </div>
  </div>
)

const renderAreaList = (tagsData) => {

  const [extListState, performExtList, resetExtList] = useAction(getExtList);

  let [tabText, setTabText] = useState(null);
  let [tabIndex, setTabIndex] = useState(0);
  let [extList, setExtList] = useState(null);
  let [arrowDirect, setArrowDirect] = useState(false); // true 为箭头向上 点击收起

  let firstId = tagsData?.list && tagsData?.list[0] && tagsData?.list[0]?.id

  useEffect(() => {
    resetExtList();
    performExtList({
      tagId: firstId || null,
    });
  }, []);

  useEffect(() => {
    if (tagsData?.list?.length >= 1) {
      const tabState = tagsData?.list || [];
      if (tagsData?.list?.length > 8) {
        setTabText(tabState.slice(0, 8));
      } else {
        setTabText(tabState);
      }
    }
  }, [tagsData]);

  useEffect(() => {
    const respCode = R.prop("respCode", extListState);
    const respData = R.prop("respData", extListState);
    if (respCode === 0) {
      setExtList(respData?.list || []);
    }
  }, [extListState.respData]);

  const handleClickTab = useCallback(
    ({ item, idx }) => {
      performExtList({
        tagId: item?.id || null,
      });
      setTabIndex(idx);
    },
    [tabIndex]
  );

  const handleClickArrow = useCallback(() => {
    if (arrowDirect) {
      setTabText((tabText || []).slice(0, 8));
    } else {
      const tabState =tagsData?.list || [];
      setTabText(tabState);
    }
    setArrowDirect((prev) => !prev);
  });

  if (extList === null) return null;

  return (
    <div className={styles["area-list-content"]}>
      <div className={styles["total-taber"]}>
        {(tabText || []).map((item, idx) => (
          <div
            className={classnames(
              styles["total_tab"],
              styles[tabIndex === idx ? "tab_active" : ""]
            )}
            key={`total_tab_one_${idx}`}
            onClick={() => {
              handleClickTab({ item, idx });
            }}
          >
            <span>{item.tagName || ""}</span>
          </div>
        ))}

        {tagsData?.list?.length > 8 && (
          <div
            className={classnames(styles["select-more"])}
            onClick={() => {
              handleClickArrow();
            }}
          >
            <i
              className={classnames(
                styles["select-arrow"],
                styles[arrowDirect ? "up" : "down"]
              )}
            ></i>
          </div>
        )}

      </div>
      {extList === null || extList.length <= 0 ? (
        extList !== null ? (
          <Empty
            image={imgEmpty}
            description={<span>尚未有小程序上架~</span>}
          />
        ) : null
      ) : (
        renderAppList(extList)
      )}
    </div>
  );
};


function App({data: { tagsData = {} }}) {
  yaReportArr.push({
    eid: 'sys/pageview/appstore/home',
    eid_desc: '小程序商店首页访问',
  })

  return (
    <div className={styles['home-container']}>
      <div className={styles['home-container-left']}>
        <AppSlider/>
        { renderAreaList(tagsData) }
      </div>

      <div className={styles['home-container-right']}>
        <AppList type={'popular'} title={'人气榜'}/>
        <AppList type={'rich'} title={'财富榜'}/>
      </div>
    </div>
  )
}

export default Home;
